var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.357 9.27332L6.30217 21.0612C5.98813 21.3961 5.44945 21.0244 5.65102 20.612L9.58346 12.5653C9.71332 12.2996 9.51985 11.9897 9.22408 11.9897H0.93291C0.581295 11.9897 0.400753 11.5686 0.643163 11.3139L10.8994 0.537741C11.2043 0.217408 11.7268 0.555597 11.5594 0.964917L8.62013 8.15218C8.51168 8.41738 8.70903 8.70725 8.99552 8.70356L17.06 8.59973C17.4127 8.59519 17.5982 9.01608 17.357 9.27332Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.6888f2d32c7d4f209e4d940610a015dc.svg";
export { ForwardRef as ReactComponent };